import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef } from '@angular/core';

import { Errors, SellerService, LocalService, ManagerService, FileService, ProfileService } from '../../../../core';
import { PopupMessageService } from '../../../../shared/message/services/message.service';
import { managerApi } from '../../../../config';
import { SegmentedToggleOption } from '../../../../shared/ui/segmented-toggle/segmented-toggle.component';
import { DataTableColumn, DataTableSortDirection } from '../../../../shared/ui/data-table/data-table.component';
import { BadgeVariant } from '../../../../shared/ui/badge/badge.component';

@Component({
  selector: 'app-admin-claimed-deals',
  templateUrl: './admin-claimed-deals.component.html',
  styleUrls: ['./admin-claimed-deals.component.scss']
})
export class AdminClaimedDealsComponent implements OnInit, AfterViewInit {
  errors: Errors = { errors: {} };
  userProfile: any;

  pageNo = 0;
  size = 5;
  sortBy: any;

  searchData = '';
  searchValue: any;
  searchCustomer: any;

  claimedDeals: any;
  claimedDealsPage = 0;

  rewardType = 'POINTS';
  companyRewardType = 'POINTS';

  rewardTypeOptions: SegmentedToggleOption[] = [
    { label: 'Points Earnings', value: 'POINTS' },
    { label: 'Cash Earnings', value: 'CASH' }
  ];

  statusOptions: any[] = [
    { label: 'All Status', value: 'all' },
    { label: 'Approved', value: 'APPROVED' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Denied', value: 'DENIED' }
  ];

  selectedStatusOption: any = { label: 'All Status', value: 'all' };

  sellerOptions: any[] = [];
  selectedSellerOptions: any[] = [];

  @ViewChild('statusBadgeTpl') statusBadgeTpl!: TemplateRef<any>;

  newClaimedColumns: DataTableColumn[] = [];
  newClaimedPage = 1;
  newClaimedSortBy = '';
  newClaimedSortDir: DataTableSortDirection = '';
  formattedClaimedDeals: any[] = [];

  constructor(
    private sellerService: SellerService,
    private managerService: ManagerService,
    private fileService: FileService,
    private popupMessageService: PopupMessageService,
    private profileService: ProfileService,
  ) {}

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    this.loadCompanyPreferences();
    this.loadSellersList();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const rewardTypeLabel = this.rewardType === 'POINTS' ? '(Points)' : '(Cash)';
      this.newClaimedColumns = [
        { field: 'bookingDateFormatted', header: 'Booking Date', align: 'center', sortable: true },
        { field: 'poNumber', header: 'PO Number', align: 'center' },
        { field: 'customerName', header: 'Customer Name', align: 'center' },
        { field: 'claimedBy', header: 'Claimed By', align: 'center' },
        { field: 'challengeId', header: 'Challenge Name', align: 'center' },
        { field: 'rewardsFormatted', header: `Rewards Earned ${rewardTypeLabel}`, align: 'center', isBold: true },
        { field: 'poStatus', header: 'Claim Status', align: 'center', cellTemplate: this.statusBadgeTpl },
        { field: 'comments', header: 'Comments', align: 'center' }
      ];
    });
  }

  private loadCompanyPreferences(): void {
    if (this.userProfile && this.userProfile.company && this.userProfile.company.id) {
      const companyParams = { companyId: this.userProfile.company.id };
      this.managerService.getCompanyPreferences(companyParams).subscribe(
        (data) => {
          const companyRewardTypeSel = data.companyPreferences.find((item: any) => item.id === 15 && item.name === 'COMPANY_REWARDTYPE_POINTS');
          const rewardTypeCash = data.companyPreferences.find((item: any) => item.id === 16 && item.name === 'COMPANY_REWARDTYPE_CASH');
          if (companyRewardTypeSel.enabled) {
            this.rewardType = 'POINTS';
            this.companyRewardType = 'POINTS';
          } else {
            this.rewardType = 'CASH';
            this.companyRewardType = 'CASH';
          }
          if (companyRewardTypeSel.enabled === false && rewardTypeCash.enabled === false) {
            this.rewardType = 'POINTS';
            this.companyRewardType = 'POINTS';
          }
          this.getClaimedDeals();
        },
        (err) => {
          this.errors = err;
          this.getClaimedDeals();
        }
      );
    }
  }

  onRewardTypeChange(value: string): void {
    this.rewardType = value;
    const rewardTypeLabel = value === 'POINTS' ? '(Points)' : '(Cash)';
    const rewardEarnedIndex = this.newClaimedColumns.findIndex(col => col.field === 'pointsEarned');
    if (rewardEarnedIndex !== -1) {
      this.newClaimedColumns[rewardEarnedIndex].header = `Rewards Earned ${rewardTypeLabel}`;
    }
    this.getClaimedDeals();
  }

  onClaimedStatusFilterChange(selectedStatus: any): void {
    this.selectedStatusOption = selectedStatus;
    this.getClaimedDeals();
  }

  onSellerFilterChange(selected: any[]): void {
    this.selectedSellerOptions = selected;
    this.pageNo = 0;
    this.newClaimedPage = 1;
    this.getClaimedDeals();
  }

  private loadSellersList(): void {
    this.profileService.companyAllUsers(this.userProfile.company.id).subscribe(
      (data: any[]) => {
        if (data) {
          const unique: any[] = [];
          data.forEach((item: any) => {
            if (unique.find((u: any) => u.id === item.id) === undefined) {
              unique.push({ id: item.id, fullName: `${item.firstName} ${item.lastName}` });
            }
          });
          this.sellerOptions = unique
            .map((u: any) => ({ label: u.fullName, value: u.id }))
            .sort((a: any, b: any) => a.label.localeCompare(b.label));
        }
      },
      (err: any) => { this.errors = err; }
    );
  }

  onNewClaimedPageChange(page: number): void {
    this.newClaimedPage = page;
    this.getMoreClaimedDeals({ pageIndex: page - 1, pageSize: this.size });
  }

  onNewClaimedSortChange(event: { sortBy: string; sortDir: DataTableSortDirection }): void {
    this.newClaimedSortBy = event.sortBy;
    this.newClaimedSortDir = event.sortDir;
    const backendFieldMap: Record<string, string> = {
      'bookingDateFormatted': 'bookingDate'
    };
    const backendField = backendFieldMap[event.sortBy] ? backendFieldMap[event.sortBy] : event.sortBy;
    this.getclaimedDealssortData({
      active: backendField,
      direction: event.sortDir || 'asc'
    });
  }

  getClaimedDeals() {
    const params: any = {
      page: this.pageNo,
      size: this.size,
      companyId: this.userProfile.company.id,
      pointsRewardType: this.rewardType
    };
    if (this.selectedStatusOption && this.selectedStatusOption.value !== 'all') {
      params.claimStatus = this.selectedStatusOption.value;
    }
    if (this.selectedSellerOptions && this.selectedSellerOptions.length > 0) {
      params.userIds = this.selectedSellerOptions.map((s: any) => s.value).join(',');
    }
    if (this.sortBy) {
      params.sortBy = this.sortBy.active;
      params.sortDir = this.sortBy.direction;
    }
    if (this.searchCustomer) {
      params['searchText'] = this.searchCustomer;
    }
    this.managerService.pointAccountSellerClaimedBySeller(params).subscribe(
      (data) => {
        this.claimedDeals = data;
        this.formatClaimedDeals();
      },
      (error) => {
        this.errors = error;
      }
    );
  }

  searchCustomerName(value: string, flag?: boolean) {
    value = value.trim();
    if (!flag) {
      this.searchCustomer = value;
      if (value.length > 0) {
        this.claimedDealsPage = 0;
        this.getClaimedDeals();
      }
    }
    if (flag && value.length === 0) {
      this.claimedDealsPage = 0;
      this.searchCustomer = '';
      this.getClaimedDeals();
    }
  }

  getclaimedDealssortData(sortByStatus?: any) {
    this.sortBy = sortByStatus;
    this.sortBy.direction = this.sortBy.direction.toUpperCase();
    this.getClaimedDeals();
  }

  getMoreClaimedDeals(pageNumber: any) {
    this.size = pageNumber.pageSize;
    this.claimedDealsPage = pageNumber.pageIndex;
    const params = {
      page: this.claimedDealsPage,
      size: this.size,
      companyId: this.userProfile.company.id,
      pointsRewardType: this.rewardType
    };
    this.managerService.pointAccountSellerClaimedBySeller(params).subscribe(
      (data) => {
        if (data.content) {
          this.claimedDeals.number = data.number;
          this.claimedDeals.content = data.content;
          this.formatClaimedDeals();
        }
      },
      (err) => {
        this.errors = err;
      }
    );
  }

  formatClaimedDeals(): void {
    if (!this.claimedDeals || !this.claimedDeals.content) {
      this.formattedClaimedDeals = [];
      return;
    }
    this.formattedClaimedDeals = this.claimedDeals.content.map((deal: any) => {
      const date = deal.bookingDate ? new Date(deal.bookingDate) : null;
      const statusVariant = this.getStatusBadgeVariant(deal.poStatus);
      const formatted = {
        ...deal,
        netBookings: this.splitData(deal.netBookings),
        pointsEarned: this.splitData(deal.pointsEarned),
        pointsEarnedCash: deal.pointsEarned / 200,
        bookingDateFormatted: date ? date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : '',
        rewardsFormatted: this.rewardType === 'POINTS'
          ? this.splitData(deal.pointsEarned)
          : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(deal.pointsEarned / 200),
        statusVariant: statusVariant ? statusVariant : 'secondary'
      };
      return formatted;
    });
  }

  getStatusBadgeVariant(status: string): BadgeVariant {
    switch ((status || '').toLowerCase()) {
      case 'approved':
        return 'success';
      case 'pending':
        return 'warning';
      case 'denied':
        return 'error';
      default:
        return 'secondary';
    }
  }

  splitData(value: any) {
    const parseValue = parseFloat(value);
    const newData = parseValue.toLocaleString();
    return newData.toString();
  }

  downloadExcel() {
    const url: string = managerApi.claimStatusHistory + `?page=0&size=100000&companyId=${this.userProfile.company.id}&excel=true` + '&pointsRewardType=' + this.rewardType;
    const fileName: string = 'Claim_Status_History_' + this.userProfile.company.id + '.xlsx';
    this.fileService.excelDownloadFile(url, fileName);
  }
}
